import { render, staticRenderFns } from "./putstore.vue?vue&type=template&id=093086d6&"
import script from "./putstore.vue?vue&type=script&lang=js&"
export * from "./putstore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports